import { render, staticRenderFns } from "./BLUV2ToggleColumnsModal.vue?vue&type=template&id=04397ebe&scoped=true"
import script from "./BLUV2ToggleColumnsModal.vue?vue&type=script&lang=js"
export * from "./BLUV2ToggleColumnsModal.vue?vue&type=script&lang=js"
import style0 from "./BLUV2ToggleColumnsModal.vue?vue&type=style&index=0&id=04397ebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04397ebe",
  null
  
)

export default component.exports